// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wawp","controls":"styles_controls__1B0jc","charLimit":"styles_charLimit__bCpzv","input":"styles_input__m9O8x","send":"styles_send__3rVIu"};